import { backendConfig } from "../config/BackendConfig";
import { axiosInstance } from "./AxiosInterceptor";

export const getEventsAndNotifications = (queryParam) => {
  /**End Point:- getEventsAndNotifications**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getEventsAndNotifications,
    queryParam
  );
};

/**
 * @param {
 *  userId: string [userCognitoData.username],
 *  siteId: string,
 *  eventType: string  [All || cartridge || clo2Value || connectivity || deviceEvents || faults],
 *  showEvent: booean,
 *  duration: 24,
 *  isListed: true,
 *  deviceId: Taabish_Test_device016
 * } queryParam
 * @returns Promise
 */

export const markAsRead = (queryParam) => {
  /**End Point:- markEventsAsRead**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.markEventsAsRead,
    queryParam
  );
};

export const setNotificationPreference = (queryParam) => {
  /**End Point:- setNotificationPreference**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.setNotificationPreference,
    queryParam
  );
};
